import { NOT_AVAILABLE } from '../check-batch/format';
import type { ContractorBatchLine } from './types';

/** One check number, or "first - last" when the batch writes more than one check. */
export function checkNumberRange(numbers: string[]): string {
  if (numbers.length === 0) return NOT_AVAILABLE;
  if (numbers.length === 1) return numbers[0]!;
  return `${numbers[0]} - ${numbers[numbers.length - 1]}`;
}

/** "12.5 hrs x $80.0000" for hours x rate; "Flat amount" otherwise. The check amount beside it is always the server's. */
export function earningsText(line: ContractorBatchLine): string {
  if (line.amountMode === 'HoursRate' && line.hours !== null && line.rate !== null) {
    return `${line.hours} hrs × $${line.rate.toFixed(4)}`;
  }
  return 'Flat amount';
}

